import { Card, Statistic } from 'antd';
import React, { CSSProperties } from 'react';

import type { StatisticProps } from 'antd/es/statistic/Statistic';

interface StaticCardProps {
  title: string;
  value: any;
  className?: string;
  variant?: 'success'|'primary' | 'secondary' | 'error' | 'warning' | 'green' | 'notif';
  statisticProps?: StatisticProps;
  valueStyle?:CSSProperties
  width?:string;
  height?:string;

}

const StaticCard: React.FC<StaticCardProps> = ({
  title,
  value,
  className,
  variant = 'info',
  statisticProps,
  valueStyle,
  width,
  height
}) => (
  <Card className={`${className} ${[`staticCard staticCard-${variant}`]} ${className || ''}`} style={{ width: width??"100%",height:height??"100%"} }>
    <Statistic
      title={title}
      value={value}
      valueStyle={valueStyle}
      {...statisticProps}

    />
  </Card>
);

export default StaticCard;